import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useLayoutEffect
} from 'react';
import { useDispatch } from 'react-redux';
import { notCloseExtraProtocolModal } from 'store/action/sideDrawerActions';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import { Alert } from 'reactstrap';
import { Row, Form, Col, Input, Button } from 'reactstrap';
import { FaHistory, FaRegCalendarAlt } from 'react-icons/fa';
import Select from 'react-select/async';
import Tour from 'reactour';
import Loader from 'react-loader-spinner';

import FlexSelect from 'components/Inputs/FlexSelect';
import { FlexController } from 'components/FlexControllerInput';
import ProtocolConfigService from '../../../../ProtocolConfiguration/service';
import ProtocolService from '../../../service';
import SubReasonService from '../../../../subReason/service';
import RecordTypeService from '../../../../RecordType/service';
import CustomerPortfolioService from '../../../../SLA/CustomerPortfolio/service';
import ServiceClassificationService from '../../../../SLA/MatrixSLA/components/serviceClassifications/service';
import ServiceChannelService from '../../../../ServiceChannel/service';

import ContactService from '../../../../CRM/Contact/services/contactService';

import { steps } from '../../assets/steps';
import {
  maskPhone,
  definedShowName,
  validateFields
} from '../../assets/functions';
import ModalFilterClients from '../../../../Clients/components/ModalFilterClients';
import { custom_select } from '../../../../../assets/styles/multiple_select';
import ReactLoader from 'components/Loader';
import { useSearchClients } from '../../hooks/useSearchClients';
import { useFetchUsersByRecordType } from '../../hooks/useFetchUsersByRecordType';
import { useProtocolDefaultFieldsSettings } from '../../../../fieldConfigs/hooks/useProtocolDefaultFieldsSettings';
import { useListReasonByRecordType } from '../../../../reason/list/hooks/useListReasonByRecordType';
import { useListStatusByRecordType } from '../../../../status/list/hooks/useListStatusByRecordType';
import { ClientProtocolModal } from 'views/Clients/list/components/ClientProtocol/components/ClientProtocolModal';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';

import { removeMaskSpecialCharacters } from 'views/CRM/shared/utils/phoneNumberHelpers';
import { formatCustomFieldsToSubmit } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { useSearchAccounts } from 'views/CRM/Account/hooks/useSearchAccounts';
import { getDefaultCountry } from 'services/ServiceCOUNTRYS';
import { normalizePhoneNumber } from 'utils/fuctions/internationalPhoneFormatter';
import { normalizeDDI } from 'utils/fuctions/internationalPhoneFormatter';
import AddContactModal from '../AddContactModal';
import ModalSchedulingProtocol from '../ModalSchedulingProtocol';

// react-grid-layout
import { DescriptionQuillContainer, StyledGridLayout } from './styles';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import CustomFieldsInputsForm from 'views/CRM/shared/components/CustomFieldsInputsForm';
import { useCustomFields } from '../../context/CustomFieldsContext';
import Counter from '../Counter';
import {
  AreaPreviewProtocol,
  FileProtocolArea,
  UploadButtonProtocol,
  ServiceClassificationNameWrapper
} from '../styledComponents/styled';
import { FiUpload } from 'react-icons/fi';
import { ListFileAttachments } from 'views/CRM/shared/components/ListFileAttachments/ListFileAttachments';
import { FileAttachments } from 'views/CRM/shared/components/ListFileAttachments/FileAttachments';
import { AddNewContactButton } from 'components/Buttons/AddNewContactButton';
import { SearchContactButton } from 'components/Buttons/SearchContactButton';

import { formatTimeToDHM } from '../../../updateForm/components/ModalSLAInfo/utils';
import { saveObjectToLocalStorage } from 'utils/fuctions/localStorage';
import { LOCAL_STORAGE_KEYS } from 'utils/fuctions/localStorage';
import { getIdClientFromChat } from 'utils/fuctions/getIdClientFromChat';

import AddAccountModal from '../../../../CRM/Contact/form/AddAccountModal/index';
import EditAccountModal from '../../../../CRM/Contact/form/EditAccountModal/EditAccountModal';
import AccountService from '../../../../CRM/Account/services/accountService';
import ModalConfirmAssociateContact from '../ModalConfirmAssociateContact';

const _ = require('lodash');

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    [{ font: [] }],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    ['link', 'image', 'code-block'],
    ['clean']
  ]
};

const ProtocolForm = (props) => {
  /**
   * Converte um telefone do formato string para o formato objeto esperado pelo FlexController
   * @param {string} phone - Telefone no formato string
   * @returns {object} - Objeto com ddi e number
   */
  const convertPhoneToFlexControllerFormat = (phone) => {
    if (!phone) {
      return {
        ddi: getDefaultCountry()?.dialCode || '',
        number: ''
      };
    }

    if (typeof phone === 'object' && phone.ddi && phone.number) return phone;

    return {
      ddi: getDefaultCountry()?.dialCode || '',
      number: phone
    };
  };

  const propsMemo = useMemo(() => props, [props]);
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const emailRegex = useMemo(() => {
    // eslint-disable-next-line no-useless-escape
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
  }, []);

  const fileAttachmentsPreview = useMemo(
    () => new FileAttachments(),
    [loadingFile]
  );

  const attachments = useMemo(
    () => fileAttachmentsPreview.attachments,
    [fileAttachmentsPreview.attachments]
  );

  const loggedInUser = localStorage.getItem('login');

  const closeModal = propsMemo?.modalActions?.closeModal;
  const defaultFormData = propsMemo?.modalActions?.defaultFormData;

  const selectedRecordTypeId =
    defaultFormData?.protocol?.record_type_id ??
    propsMemo?.selectedRecordTypeId;

  const {
    inAttendanceScreen = false,
    setProtocolCreated = () => {},
    conversation = '',
    activeFormCreatedProtocol = false,
    forceSaveProtocol,
    startCounter
  } = propsMemo;

  const protocolTelephoneNumber = defaultFormData?.telephoneNumber ?? '';
  const getProtocolConfig = async () => {
    const responseConfigProtocol = await ProtocolConfigService.getConfigs(
      recordType
    );
    setConfig(responseConfigProtocol?.data?.content);
  };

  // Dados disponíveis quando esse componente é rederizado por um modal (no caso no painel de atendimento)
  const [loadingSubreasons, setLoadingSubreasons] = useState(false);

  const setProtocol =
    propsMemo?.setProtocol && inAttendanceScreen ? propsMemo.setProtocol : '';

  const setActiveFormCreatedProtocol =
    propsMemo?.setActiveFormCreatedProtocol ?? '';

  const isProtocolAlreadyCreated = defaultFormData?.protocol;

  //Formulário
  const { control, handleSubmit, errors, setValue, reset, watch } = useForm();
  const formValues = watch();

  //States
  const [config, setConfig] = useState(null);
  const [layouts, setLayouts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tourOpen, setTourOpen] = useState(false);
  const [subReasons, setSubReasons] = useState([]);
  const [nameClient, setNameClient] = useState('');
  const [recordType] = useState(selectedRecordTypeId);
  const [recordTypeData, setRecordTypeData] = useState(null);
  const [messageError, setMessageError] = useState('');
  const [loadingForm, setLoadingForm] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);
  const [selectedClient, setSelectClient] = useState('');
  const [pauseCounter, setPauseCounter] = useState(true);
  const [errorInUpload, setErrorInUpload] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState();
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [clientDefaultData, setClientDefaultData] = useState({});
  const [isLayoutsUpdated, setIsLayoutsUpdated] = useState(false);
  const [loadingSubReasons, setLoadingSubReasons] = useState(false);
  const [isSchedulingModalOpen, setIsSchedulingModalOpen] = useState(false);
  const [isClientSearchModalOpen, setIsClientSearchModalOpen] = useState(false);
  const [customerPortfolio, setCustomerPortfolio] = useState(null);
  const [serviceChannelOptions, setServiceChannelOptions] = useState([]);

  const [serviceClassificationName, setServiceClassificationName] =
    useState(null);
  const [
    isLoadingServiceClassificationName,
    setIsLoadingServiceClassificationName
  ] = useState(false);

  const [controlValidSelectClient, setControlValidSelectClient] =
    useState(false);
  const [controlValidSelectAccount, setControlValidSelectAccount] =
    useState(false);
  const [isHistoryModalProtocolOpen, setIsHistoryModalProtocolOpen] =
    useState(false);
  const [successCreateProtocolo, setSuccessCreateProtocolo] = useState({
    success: false,
    idProtocol: null
  });
  const [protocolNumber, setProtocolNumber] = useState(
    defaultFormData?.protocol?.number
  );
  const [isAccountSearchModalOpen, setIsAccountSearchModalOpen] =
    useState(false);
  const [isEditAccountModalOpen, setIsEditAccountModalOpen] = useState(false);
  const [accountResponse, setAccountResponse] = useState({});
  const [showAssociateModal, setShowAssociateModal] = useState(false);
  const [pendingSubmit, setPendingSubmit] = useState(null);
  const [contactAccountId, setContactAccountId] = useState(null);

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const onlyDigits = (str = '') => String(str || '').replace(/\D/g, '');
  const normalizeEmail = (s = '') =>
    String(s || '')
      .trim()
      .toLowerCase();

  const watchedTelephone = watch('telephone');
  const watchedEmail = watch('email');

  const selectedAccountRef = React.useRef(null);
  // Pula a próxima hidratação automática de conta (usado no clone)
  const skipHydrateOnceRef = React.useRef(false);
  const autoPickTimerRef = React.useRef(null);
  const descriptionRef = React.useRef(null);

  useEffect(() => {
    selectedAccountRef.current = selectedAccount;
  }, [selectedAccount]);

  const onAddedAccount = useCallback((data) => {
    setSelectedAccount({
      id: data.id,
      name: data.name,
      recordTypeId: data.record_type_id
    });
  }, []);

  // Remoção de logs de depuração: observar mudanças na conta selecionada (removido)

  const getAccount = useCallback(async (recordTypeId, id) => {
    try {
      const response = await AccountService.getById(recordTypeId, id);
      setAccountResponse(response?.data?.data);
    } catch {
      toast.error('Ocorreu um erro ao buscar informações da conta');
    }
  }, []);

  const handleEditAccount = useCallback(async () => {
    if (selectedAccount && selectedAccount.recordTypeId && selectedAccount.id) {
      await getAccount(selectedAccount.recordTypeId, selectedAccount.id);
      setIsEditAccountModalOpen(true);
    } else {
      toast.error('Nenhuma conta selecionada ou recordTypeId inválido');
    }
  }, [getAccount, selectedAccount]);

  const hydrateAccountFromContact = useCallback(async (contactId) => {
    if (!contactId) {
      setSelectedAccount(null);
      setContactAccountId(null);
      return;
    }

    try {
      const resp = await ContactService.getContactById(contactId);
      const contact = resp?.data?.data;
      const accounts = contact?.accounts || [];
      let acc = null;

      if (accounts.length > 0) {
        acc = {
          id: accounts[0].accountId,
          name: accounts[0].accountName,
          recordTypeId: accounts[0].recordTypeId
        };
        if (accounts.length > 1) {
          toast.info(
            `O contato "${contact.name}" possui ${accounts.length} contas associadas. A primeira conta cadastrada foi selecionada automaticamente.`
          );
        }
      }

      setContactAccountId(acc?.id ?? null);

      if (acc?.id) {
        setSelectedAccount(acc);
      } else {
        setSelectedAccount(null);
      }
    } catch (e) {
      console.error('Erro ao hidratar conta pelo contato:', e);
      setSelectedAccount(null);
      setContactAccountId(null);
    }
  }, []);

  const getFirstAccount = useCallback(async (params) => {
    try {
      const resp = await AccountService.getAllAccounts(params, {
        page: 1,
        limit: 10
      });
      const list = resp?.data?.data ?? [];
      return Array.isArray(list) && list.length ? list[0] : null;
    } catch (err) {
      console.error('Falha ao buscar contas:', err);
      return null;
    }
  }, []);

  const trySelectAccountByComm = useCallback(
    async ({ phoneNumber, email }) => {
      if (selectedAccountRef.current) return false;

      const rawPhone =
        typeof phoneNumber === 'object' ? phoneNumber?.number : phoneNumber;
      const ddiFromField =
        typeof phoneNumber === 'object' ? phoneNumber?.ddi || '' : '';
      const telDigits = onlyDigits(rawPhone);
      const ddiDigits = onlyDigits(ddiFromField);

      if (telDigits) {
        const params = ddiDigits
          ? { telephone: telDigits, ddi: ddiDigits }
          : { telephone: telDigits };
        const acc = await getFirstAccount(params);
        if (acc) {
          await sleep(1000);
          setSelectedAccount({
            id: acc.id,
            name: acc.name,
            recordTypeId: acc.recordTypeId
          });
          return true;
        }
      }

      const emailNorm = normalizeEmail(email);
      if (emailNorm) {
        const acc = await getFirstAccount({ email: emailNorm });
        if (acc) {
          await sleep(1000);
          setSelectedAccount({
            id: acc.id,
            name: acc.name,
            recordTypeId: acc.recordTypeId
          });
          return true;
        }
      }

      return false;
    },
    [getFirstAccount, setSelectedAccount]
  );

  const associateContactToAccount = useCallback(
    async (contactId, accountId) => {
      if (!contactId || !accountId) return false;

      const resp = await ContactService.getContactById(contactId);
      const c = resp?.data?.data;

      const existingAccountIds = Array.isArray(c?.accounts)
        ? c.accounts.map((acc) => acc.accountId)
        : [];

      const newAccountId = Number(accountId);
      if (!existingAccountIds.includes(newAccountId)) {
        existingAccountIds.push(newAccountId);
      }

      const payload = {
        name: c?.name ?? '',
        phone: c?.phone ?? '',
        ddi: c?.ddi ?? '',
        email: c?.email ?? '',
        accountIds: existingAccountIds,
        tags: Array.isArray(c?.tags) ? c.tags.map((t) => t.id) : []
      };

      await ContactService.updateContact(c.recordTypeId, contactId, payload);
      return true;
    },
    []
  );

  const proceedSaveAfterDecision = async (payload) => {
    const { dataDTO, isEndChat, isUpdate } = payload || {};
    setLoading(true);

    try {
      if (isUpdate) {
        await handleUpdateProtocol(dataDTO);
        return;
      }

      if (isEndChat) {
        const protocol = await handleCreateProtocol(dataDTO, isEndChat);
        if (!protocol) return;
        let info = protocol?.data?.content || {};
        info.protocolAlreadyCreated = true;
        setActiveFormCreatedProtocol(false);
        setProtocolCreated(true);
        setProtocol({ data: info, sucess: true });
        toast.success('Protocolo criado com sucesso');
        return;
      }

      const protocol = await handleCreateProtocol(dataDTO);
      toast.success('Protocolo criado com sucesso');
      if (inAttendanceScreen && protocol) {
        handleCreateProtocolEndChat(dataDTO);
      }
    } catch (err) {
      const msg = err?.response?.data?.message;
      toast.error(msg || 'Erro ao salvar protocolo', {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmAssociate = async () => {
    try {
      if (!pendingSubmit) return;
      await associateContactToAccount(selectedClient, selectedAccount?.id);
      setContactAccountId(selectedAccount?.id || null);
      toast.success('Contato associado à conta com sucesso!', {
        autoClose: 2500,
        closeOnClick: true
      });
      setShowAssociateModal(false);
      await proceedSaveAfterDecision(pendingSubmit);
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message;
      toast.error(msg || 'Não foi possível associar o contato à conta.', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const handleContinueWithoutAssociate = async () => {
    if (!pendingSubmit) return;
    setShowAssociateModal(false);
    await proceedSaveAfterDecision(pendingSubmit);
  };

  const getServiceChannels = useCallback(() => {
    ServiceChannelService.getWithoutPagination()
      .then((res) => {
        const data = res.data;
        const list = (Array.isArray(data) ? data : []).map((canal) => ({
          label: canal.name,
          value: canal.key
        }));
        setServiceChannelOptions(list);
      })
      .catch((err) => {
        console.error('Erro ao buscar canais:', err);
      });
  }, []);

  useEffect(() => {
    const noContact = !selectedClient;
    const noAccount = !selectedAccountRef.current;
    if (!noContact || !noAccount) return;

    const phone = watchedTelephone;
    const email = watchedEmail;

    const hasPhone =
      (phone && typeof phone === 'object' && phone.number) ||
      (phone && typeof phone === 'string' && phone);
    const hasEmail = !!email;

    if (!hasPhone && !hasEmail) return;

    if (autoPickTimerRef.current) clearTimeout(autoPickTimerRef.current);
    autoPickTimerRef.current = setTimeout(() => {
      trySelectAccountByComm({ phoneNumber: phone, email });
    }, 400);

    return () => {
      if (autoPickTimerRef.current) {
        clearTimeout(autoPickTimerRef.current);
        autoPickTimerRef.current = null;
      }
    };
  }, [selectedClient, watchedTelephone, watchedEmail, trySelectAccountByComm]);

  const layoutsWithButtons = [
    ...layouts,
    { i: 'save', x: 0, y: 3000, w: 3000, h: 1 }, // Exemplo de layout para o botão "Salvar"
    { i: 'cancel', x: 2, y: 3000, w: 3000, h: 1 } // Exemplo de layout para o botão "Cancelar"
  ];

  const sortedLayouts = useMemo(() => {
    const sorted = layoutsWithButtons.sort((a, b) => {
      if (a.y === b.y) {
        return a.x - b.x;
      }
      return a.y - b.y;
    });

    return sorted;
  }, [layoutsWithButtons]);

  useLayoutEffect(() => {
    const element = document.getElementById('fecharDynamicLayoutModal');
    dispatch(notCloseExtraProtocolModal());
    if (element && props.isFromUpdate === 'true') {
      element.click();
    }
  }, []);

  //hooks
  const { users } = useFetchUsersByRecordType(recordType);

  const { changeFieldsReference } = useCustomFields();
  const { isSearching, filterClients } = useSearchClients();
  const { filterAccounts, isSearching: isSearchingAccounts } =
    useSearchAccounts();
  const { reasons, getReasonsByRecordType } =
    useListReasonByRecordType(recordType);
  const { status, getStatusByRecordType } =
    useListStatusByRecordType(recordType);
  const { protocolDefaultFieldsDisplaySettings } =
    useProtocolDefaultFieldsSettings(recordType);

  const { customFields, getCustomFields, isLoadingCustomFields } =
    useEntityCustomFieldsByRecordType('PROTOCOL', recordType);

  const currentSelectedReasonId = watch('reason_id');
  const currentSelectedSubReasonId = watch('subreason_id');

  const protocolFields = useMemo(() => {
    let arrDefaultFields = [];

    for (const key in protocolDefaultFieldsDisplaySettings) {
      if (
        protocolDefaultFieldsDisplaySettings.hasOwnProperty(key) &&
        protocolDefaultFieldsDisplaySettings[key].isActive
      ) {
        {
          arrDefaultFields.push(key);
        }
      }
    }

    const arrCustomFields = customFields.map((item) => item.name);

    const info = [...arrDefaultFields, ...arrCustomFields];

    return info;
  }, [protocolDefaultFieldsDisplaySettings, customFields]);

  const usersOptions = (users || [])?.map(({ name, login }) => ({
    label: name,
    value: login
  }));

  const validateResendAttachments = async () => {
    const existAttachments = fileAttachmentsPreview.attachmentsSubmited.length;
    const { success, idProtocol } = successCreateProtocolo;
    if (!errorFormMessage || !success || !idProtocol) return false;

    if (existAttachments) {
      if (!(await handlerUploadFiles(idProtocol))) {
        setLoading(false);
        return false;
      }

      toast.success('Anexos enviados com sucesso!.', {
        autoClose: 3000,
        closeOnClick: true
      });
      closeModal();
      fileAttachmentsPreview.reset();
      return true;
    }

    setSuccessCreateProtocolo({
      success: true,
      idProtocol: defaultFormData.protocol.id
    });

    toast.success('Protocolo atualizado sem anexos', {
      autoClose: 3000,
      closeOnClick: true
    });

    closeModal();

    setLoading(false);
    return true;
  };

  const handleUpdateProtocol = async (dataDTO) => {
    const { id: protocolId } = defaultFormData.protocol;
    delete dataDTO.number;
    await ProtocolService.updateNoStrictByRecordType(
      protocolId,
      recordType,
      dataDTO
    );

    if (defaultFormData.protocol.id) {
      setSuccessCreateProtocolo({
        success: true,
        idProtocol: protocolId
      });

      const result = await handlerUploadFiles(protocolId);
      if (!result) {
        toast.success('Protocolo atualizado sem anexos', {
          autoClose: 3000,
          closeOnClick: true
        });
        closeModal();

        setLoading(false);
        return;
      }
    }
    localStorage.setItem('isFromUpdate', false);
  };

  const handleCreateProtocolEndChat = (dataDTO) => {
    setProtocol({ data: dataDTO, sucess: true });
    setProtocolCreated(true);
    setActiveFormCreatedProtocol(false);
    setLoading(false);
    changeFieldsReference({});
    toast.success('Protocolo salvo com sucesso ', {
      autoClose: 2000,
      closeOnClick: true
    });
    fileAttachmentsPreview.reset();
    closeModal();
    localStorage.setItem('isFromUpdate', false);
    return;
  };

  const handleCreateProtocol = async (dataDTO, isEndChat = false) => {
    const protocol = await ProtocolService.createProtocolByRecordType(
      recordType,
      dataDTO
    );

    if (protocol) {
      if (!isEndChat) {
        setSuccessCreateProtocolo({
          success: true,
          idProtocol: protocol.data.content.id
        });
      }

      const result = await handlerUploadFiles(protocol.data.content.id);
      if (!result) {
        setProtocolCreated(true);
        setLoading(false);
        closeModal();
        return protocol;
      }

      if (!isEndChat) {
        setProtocolCreated(true);
        setLoading(false);
        closeModal();
      }
      return protocol;
    }

    localStorage.setItem('isFromUpdate', false);
    return false;
  };

  const onSubmit = async (data) => {
    setLoading(true);
    if (!validateFieldsAttachments()) {
      setLoading(false);
      return;
    }

    if (await validateResendAttachments()) {
      setLoading(false);
      return;
    }

    const skipValidation = !!data.saved_automatically;
    if (
      props.createdFrom &&
      (localStorage.getItem('isFromUpdate') === true ||
        localStorage.getItem('isFromUpdate') === 'true')
    ) {
      data.parent_id = props.createdFrom;
    }

    const number = data.number || protocolNumber;
    try {
      const dataToSubmit = {
        ...data,
        number,
        acctid: propsMemo?.deafultDataAcctid || '',
        telephone: data.telephone?.number
          ? removeMaskSpecialCharacters(data.telephone.number)
          : removeMaskSpecialCharacters(data.telephone || ''),
        ddi: data.telephone?.ddi || data.telephone_ddi
      };

      const dataSubmitWithoutNull = Object.fromEntries(
        Object.entries(dataToSubmit).filter(([, v]) => v != null)
      );

      const dataDTO = formatCustomFieldsToSubmit(
        { ...dataSubmitWithoutNull, description: watch('description') },
        customFields
      );

      dataDTO.schedule = selectedSchedule;
      dataDTO.files = fileAttachmentsPreview.attachmentsSubmited.length;

      const { client_id, account_id } =
        protocolDefaultFieldsDisplaySettings || {};
      const clientIdActive = !!client_id?.isActive;
      const clientIdRequired = !!client_id?.isRequired;
      const accountActive = !!account_id?.isActive;
      const accountRequired = !!account_id?.isRequired;

      if (
        !selectedClient &&
        clientIdRequired &&
        clientIdActive &&
        !skipValidation
      ) {
        setControlValidSelectClient(true);
        setLoading(false);
        return;
      }
      if (clientIdActive && selectedClient) {
        dataDTO.client_id = selectedClient;
      }

      if (
        !selectedAccount &&
        accountRequired &&
        accountActive &&
        !skipValidation
      ) {
        setControlValidSelectAccount(true);
        setLoading(false);
        return;
      }
      if (accountActive && selectedAccount?.id) {
        dataDTO.account_id = selectedAccount.id;
      }

      const bothActive = clientIdActive && accountActive;
      const bothSelected = !!(selectedClient && selectedAccount?.id);

      let isAlreadyAssociated = false;
      if (bothActive && bothSelected) {
        try {
          const resp = await ContactService.getContactById(selectedClient);
          const contact = resp?.data?.data;
          const contactAccounts = contact?.accounts || [];
          isAlreadyAssociated = contactAccounts.some(
            (acc) => acc.accountId === selectedAccount?.id
          );
        } catch (e) {
          console.error('Erro ao verificar associação conta-contato:', e);
        }
      }

      if (bothActive && bothSelected && !isAlreadyAssociated) {
        const isEndChat = !!propsMemo?.displayEndButton;
        setPendingSubmit({
          dataDTO,
          isEndChat,
          isUpdate: !!isProtocolAlreadyCreated
        });
        setShowAssociateModal(true);
        setLoading(false);
        return;
      }

      if (isProtocolAlreadyCreated) {
        await handleUpdateProtocol(dataDTO);
        setLoading(false);
        return;
      }

      const isEndChat = !!propsMemo?.displayEndButton;

      if (isEndChat) {
        const protocol = await handleCreateProtocol(dataDTO, true);
        if (!protocol) {
          setLoading(false);
          return;
        }
        const info = {
          ...(protocol?.data?.content || {}),
          protocolAlreadyCreated: true
        };
        setActiveFormCreatedProtocol(false);
        setProtocolCreated(true);
        setProtocol({ data: info, sucess: true });
        toast.success('Protocolo criado com sucesso');

        setLoading(false);
        return;
      }

      const protocol = await handleCreateProtocol(dataDTO);
      toast.success('Protocolo criado com sucesso');
      if (inAttendanceScreen && protocol) {
        handleCreateProtocolEndChat(dataDTO);
      }

      setLoading(false);
      if (props.onProtocolUpdate) {
        props.onProtocolUpdate();
      }
    } catch (error) {
      console.log('error: ', error);
      setLoading(false);
      if (inAttendanceScreen && error) {
        setProtocol({ data: error, sucess: false });
        setProtocolCreated(true);
        setActiveFormCreatedProtocol(false);
      }
      const msg = error.response?.data?.message;
      toast.error(msg || 'Erro ao cadastrar protocolo', {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      localStorage.setItem('isFromUpdate', false);
    }
  };

  const fetchProtocolPosition = async () => {
    setLoadingForm(true);
    try {
      const response = await ProtocolConfigService.getProtocolPosition(
        recordType,
        'PROTOCOL'
      );
      const positions = response?.data?.positions;

      if (positions) {
        setLayouts(positions);
        setIsLayoutsUpdated(true);
      }
    } catch (error) {
      console.log(error);
      toast.error('Erro ao carregar a posição dos campos do protocolo', {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      setLoadingForm(false);
    }
  };

  const getSubReasonsByReasonId = async (id) => {
    setLoadingSubReasons(true);

    if (!id) {
      setSubReasons([]);
      setLoadingSubReasons(false);
      return;
    }

    try {
      const response = await SubReasonService.getByReasonId(id);
      const subReasons = response.data.content;
      const sortedSubReasons = subReasons.sort((a, b) => {
        let nameA = a.name.toUpperCase();
        let nameB = b.name.toUpperCase();
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
      });
      setSubReasons(sortedSubReasons);
    } catch (error) {
      const { data } = error.response;
      toast.error(data.message, {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      setLoadingSubReasons(false);
    }
  };

  const uploadFiles = async (protocolId) => {
    const files = fileAttachmentsPreview.getAttachmentsSubmited();

    if (!files?.length) return false;

    const formData = new FormData();
    for (const file of files) {
      formData.append('attachments', file, file.name);
    }

    return ProtocolService.addAttachments(protocolId, formData);
  };

  const validateFieldsAttachments = () => {
    const { attachmentsWithoutType, messageErrors } =
      fileAttachmentsPreview.validateFiles();

    if (attachmentsWithoutType.length) {
      setErrorInUpload(true);
      setMessageError(
        `Os arquivos ${attachmentsWithoutType.join(', ')} não são permitidos `
      );
      setLoading(false);
      return false;
    }

    if (messageErrors.length) {
      setErrorInUpload(true);
      setLoading(false);
      setMessageError(
        `Os arquivos ${messageErrors.join(', ')} não são permitidos`
      );
      return false;
    }

    return true;
  };

  const handlerUploadFiles = async (protocolId) => {
    try {
      const data = await uploadFiles(protocolId);
      if (!data) return false;
      if (data.data.content) {
        fileAttachmentsPreview.reset();
        return true;
      }
      return false;
    } catch (error) {
      console.log('error', error);
      setErrorInUpload(true);
      setMessageError(error.response?.data?.message);
      toast.error(
        error.response?.data?.message ||
          'Alguns anexos não poderam ser salvos tente novamente',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
      setProtocolCreated(true);
      return false;
    }
  };

  const handlerSelectFiles = (e) => {
    setLoadingFile(true);

    for (const file of e.target.files) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error('Tamanho máximo permitido para anexo é de 10MB');
        setLoadingFile(false);
        return;
      }

      fileAttachmentsPreview.addAttachment({
        name: file.name,
        data: file
      });
    }

    setValue('files', e.target.files);
    e.target.value = null;
    setLoadingFile(false);
  };

  const toggleHistoryModalProtocol = () => {
    setIsHistoryModalProtocolOpen(!isHistoryModalProtocolOpen);
  };

  const handleGetSubReasons = useCallback(
    async (event) => {
      let value = '';
      if (event && event.target) {
        value = event.target.value;
      } else {
        value = event;
      }

      setValue('subreason_id', null);

      await getSubReasonsByReasonId(value);
    },
    [setValue]
  );

  const forceSubmit = () => {
    onSubmit({ ...formValues, saved_automatically: true });
  };

  const openTour = () => {
    setTourOpen(true);
  };

  const closeTour = () => {
    setTourOpen(false);
  };

  useEffect(() => {
    // Salva os dados no localStorage
    if (Object.keys(formValues).length > 0) {
      saveObjectToLocalStorage(
        LOCAL_STORAGE_KEYS.SIDEDRAWER_PROTOCOL_FORM_VALUES,
        formValues
      );
    }
  }, [formValues]);

  useEffect(() => {
    const resizeQuill = () => {
      if (descriptionRef.current) {
        const quillInstance =
          descriptionRef.current.querySelector('.ql-editor');
        if (quillInstance) {
          quillInstance.dispatchEvent(new Event('resize'));
        }
      }
    };
    const timer = setTimeout(resizeQuill, 100);
    return () => clearTimeout(timer);
  }, [layouts]);

  useEffect(() => {
    const idFromChat = getIdClientFromChat(conversation);
    if (idFromChat) hydrateAccountFromContact(idFromChat);
  }, [conversation, hydrateAccountFromContact]);

  useEffect(() => {
    if (!propsMemo.modalActions.isOpen) {
      fileAttachmentsPreview.reset();
    }
  }, [propsMemo.modalActions.isOpen]);

  useEffect(() => {
    if (startCounter) setPauseCounter(false);
  }, [startCounter]);

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    getProtocolConfig();
    fetchProtocolPosition();
  }, []);

  useEffect(() => {
    setLoadingForm(isLoadingCustomFields);
  }, [isLoadingCustomFields]);

  useEffect(() => {
    getReasonsByRecordType();
  }, [getReasonsByRecordType]);

  useEffect(() => {
    getStatusByRecordType();
  }, [getStatusByRecordType]);

  useEffect(() => {
    if (defaultFormData && !isProtocolAlreadyCreated) {
      setClientDefaultData(defaultFormData);

      const client =
        (defaultFormData?.client && defaultFormData?.client?.id) || '';

      setSelectClient(client);

      let objectData = { ...defaultFormData };

      if (objectData.telephoneNumber) {
        objectData.telephone = convertPhoneToFlexControllerFormat(
          objectData.telephoneNumber
        );
      }

      //setar todos os valores possiveis que vem do socket
      Object.keys(defaultFormData).forEach((dt) => {
        if (protocolDefaultFieldsDisplaySettings) {
          if (`${dt}` === 'reason_id') {
            handleGetSubReasons(defaultFormData[dt]);
          }
        }
      });

      setClientDefaultData((prev) => ({
        ...prev,
        client: {
          ...prev.client,
          id: objectData?.client?.id,
          nome: objectData?.client?.nome
        }
      }));

      if (Object.keys(objectData).length > 0) {
        reset({
          ...objectData,
          client: objectData?.client ?? { label: '', value: '' }
        });
      }
    }
  }, [
    defaultFormData,
    protocolDefaultFieldsDisplaySettings,
    reset,
    handleGetSubReasons,
    isProtocolAlreadyCreated
  ]);

  useEffect(() => {
    if (!isProtocolAlreadyCreated) return;

    const { client, protocol } = defaultFormData || {};
    const clientId = client?.id || '';

    setClientDefaultData(defaultFormData);
    setSelectClient(clientId);

    handleGetSubReasons(protocol?.reason_id);

    delete defaultFormData?.protocol.number;
    delete defaultFormData?.protocol.telephone;
    delete defaultFormData?.protocol.current_responsible;

    reset({
      ...defaultFormData?.protocol,
      service_channel: defaultFormData?.serviceChannel
    });
  }, [reset, defaultFormData, handleGetSubReasons, isProtocolAlreadyCreated]);

  useEffect(() => {
    // Gerar Número de protocolo assim que a tela carrega
    const generateProtocolNumber = async () => {
      if (isProtocolAlreadyCreated) return;
      try {
        const response =
          await ProtocolService.generateNumberProtocolByRecordType(recordType);
        setProtocolNumber(response.data.protocol_number);
      } catch (error) {
        toast.error('Erro ao gerar número do protocolo');
      }
    };
    generateProtocolNumber();
  }, [isProtocolAlreadyCreated, recordType]);

  useEffect(() => {
    if (!conversation) return;
    const { cliente, canal } = conversation;
    const { id, id_postgres, nome, telefone, id_whatsapp } = cliente;
    const clientId = id_postgres || id;
    const clientPhone = ['whatsapp', 'sms'].includes(canal) ? telefone : '';

    alterDefaultModalData({
      clientId,
      clientName: nome,
      clientPhone
    });

    const phone = telefone || id_whatsapp;

    if (phone) {
      setValue('telephone', convertPhoneToFlexControllerFormat(phone));
    }
  }, [alterDefaultModalData, conversation, setValue]);

  useEffect(() => {
    if (!selectedClient) return;
    if (skipHydrateOnceRef.current) {
      // Consome o "pular uma vez" e não hidrata nem limpa a conta
      skipHydrateOnceRef.current = false;
      return;
    }
    setSelectedAccount(null);
    hydrateAccountFromContact(selectedClient);
  }, [selectedClient, hydrateAccountFromContact]);

  useEffect(() => {
    if (recordType) {
      setLoading(true);
      RecordTypeService.get(recordType)
        .then((res) => {
          const recordTypeData = res.data.content;
          setRecordTypeData(recordTypeData);
        })
        .catch((error) => {
          const errorMsg = error.response?.data?.message;
          toast.error(
            errorMsg || 'Erro ao buscar tipo de registro para edição'
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [recordType]);

  useEffect(() => {
    const fetchServiceClassificationName = (
      matrixId,
      reasonId,
      subReasonId
    ) => {
      setIsLoadingServiceClassificationName(true);
      const serviceCall = subReasonId
        ? ServiceClassificationService.getServiceClassificationTimeBySubreasonMatrixId(
            matrixId,
            null,
            subReasonId
          )
        : ServiceClassificationService.getServiceClassificationNameByReasondMatrixId(
            matrixId,
            reasonId
          );

      serviceCall
        .then((res) => {
          const classificationName = res.data.content;
          setServiceClassificationName(classificationName);
        })
        .catch(() => {
          setServiceClassificationName(null);
        })
        .finally(() => {
          setIsLoadingServiceClassificationName(false);
        });
    };

    if (!selectedAccount) {
      setServiceClassificationName(null);
      return;
    }

    if (!customerPortfolio) {
      setServiceClassificationName(null);
      return;
    }

    if (!customerPortfolio.sla_matrix_id) {
      const message =
        'A categoria da conta selecionada não possui SLA cadastrado';
      setServiceClassificationName(message);
      return;
    }

    if (!currentSelectedReasonId && !currentSelectedSubReasonId) {
      fetchServiceClassificationName(customerPortfolio.sla_matrix_id, '', null);
      return;
    }

    fetchServiceClassificationName(
      customerPortfolio.sla_matrix_id,
      currentSelectedReasonId,
      currentSelectedSubReasonId
    );
  }, [
    currentSelectedReasonId,
    currentSelectedSubReasonId,
    selectedAccount,
    customerPortfolio
  ]);

  useEffect(() => {
    if (!selectedAccount) {
      setCustomerPortfolio(null);
      return;
    }
    setIsLoadingServiceClassificationName(true);
    CustomerPortfolioService.getCustomerPortfolioByAccountId(selectedAccount.id)
      .then((res) => {
        const customerPortfolio = res.data.content.customer_portfolio;
        setCustomerPortfolio(customerPortfolio);
        setIsLoadingServiceClassificationName(false);
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.message;
        toast.error(errorMsg || 'Erro ao buscar portfólio do cliente');
        setCustomerPortfolio(null);
        setIsLoadingServiceClassificationName(false);
      });
  }, [selectedAccount]);

  useEffect(() => {
    if (!protocolDefaultFieldsDisplaySettings || !isLayoutsUpdated) {
      return;
    }

    const protocolDefaultFieldsDisplaySettingsKeys = new Set(
      Object.keys(protocolDefaultFieldsDisplaySettings)
    );

    const newLayouts = layouts.filter((item) => {
      const settings = protocolDefaultFieldsDisplaySettings[item.i];
      return !(
        protocolDefaultFieldsDisplaySettingsKeys.has(item.i) &&
        settings &&
        settings.isOnlyToShowOnEdit
      );
    });

    setLayouts(newLayouts);
    setIsLayoutsUpdated(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLayoutsUpdated, protocolDefaultFieldsDisplaySettings]);

  const alterDefaultModalData = useCallback(
    ({ clientId, clientName, clientPhone, clientEmail = '' }) => {
      const newDefaultData = {
        telephoneNumber: clientDefaultData && clientDefaultData.telephoneNumber,
        serviceChannel: clientDefaultData && clientDefaultData.serviceChannel,
        client: {
          id: clientId,
          nome: clientName,
          phone: clientPhone,
          email: clientEmail
        }
      };

      setClientDefaultData(newDefaultData);
      setSelectClient(clientId);
      setNameClient(clientName);
      setIsClientSearchModalOpen(false);

      const resetData = {
        telephone: maskPhone(newDefaultData?.client?.phone),
        email: clientEmail,
        client: {
          label: clientName,
          value: clientId
        }
      };

      if (resetData.telephone) {
        setValue(
          'telephone',
          convertPhoneToFlexControllerFormat(resetData.telephone)
        );
      } else {
        setValue('telephone', convertPhoneToFlexControllerFormat(''));
      }

      if (resetData.clientEmail) {
        setValue('email', resetData.clientEmail);
      } else {
        setValue('email', '');
      }

      if (resetData.client) {
        setValue('client', resetData.client);
      }
    },
    [clientDefaultData, setValue]
  );

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  useEffect(() => {
    if (!activeFormCreatedProtocol) return;
    handleSubmit(onSubmit)();
    setActiveFormCreatedProtocol(false);
  }, [activeFormCreatedProtocol, handleSubmit]);

  useEffect(() => {
    if (!protocolDefaultFieldsDisplaySettings || !isLayoutsUpdated) {
      return;
    }

    const protocolDefaultFieldsDisplaySettingsKeys = new Set(
      Object.keys(protocolDefaultFieldsDisplaySettings)
    );

    const newLayouts = layouts.filter((item) => {
      const settings = protocolDefaultFieldsDisplaySettings[item.i];
      return !(
        protocolDefaultFieldsDisplaySettingsKeys.has(item.i) &&
        settings &&
        settings.isOnlyToShowOnEdit
      );
    });

    setLayouts(newLayouts);
    setIsLayoutsUpdated(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLayoutsUpdated, protocolDefaultFieldsDisplaySettings]);

  useEffect(() => {
    if (forceSaveProtocol) {
      forceSubmit();
    }
  }, [forceSaveProtocol]);

  const renderCustomFields = () => {
    if (!customFields.length) return null;

    const customFieldsDraggables = customFields.map((field, index) => {
      let tabIndex = sortedLayouts.findIndex((item) => item.i === field.id);
      if (tabIndex === -1) {
        tabIndex = 0;
      } else {
        tabIndex = tabIndex + 1;
      }

      return field ? (
        <div
          key={field.id}
          data-grid={
            (layouts &&
              layouts.length > 0 &&
              layouts.find((item) => item.i === field.id)) || {
              x: Math.floor(Math.random() * 2) * 2,
              y: 8 + index,
              w: 2,
              h: 1,
              minW: 2,
              maxW: 4,
              minH: 1,
              maxH: 1
            }
          }
          style={{
            width: '100%',
            marginRight: '0'
          }}
        >
          <CustomFieldsInputsForm
            fields={[field]}
            control={control}
            errors={errors}
            tabIndex={tabIndex}
            watch={watch}
            setValue={setValue}
            Controller={Controller}
            draggableOptions={{
              itCanBeDragged: true,
              itIsDraggable: false
            }}
          />
        </div>
      ) : null;
    });

    return customFieldsDraggables;
  };

  useEffect(() => {
    props?.setSubReasonsFromConversations &&
      props.setSubReasonsFromConversations(subReasons);
  }, [subReasons, handleGetSubReasons]);

  const cloneParentProtocol = async () => {
    if (!props.fatherProtocol) return;
    const data = _.cloneDeep(props.fatherProtocol.protocol);
    const conta = props?.fatherProtocol?.account;
    const contato = props?.fatherProtocol?.contato;

    const newData = {};
    for (const key in data) {
      if (protocolFields.includes(key)) {
        newData[key] = data[key];
      }
    }
    if (data.reason_id) {
      await getSubReasonsByReasonId(data.reason_id);
    }

    if (protocolFields.includes('client_id') && contato) {
      skipHydrateOnceRef.current = true;
    }

    // Unifica valores em um único reset, evitando múltiplos resets em sequência
    newData.current_responsible = loggedInUser;
    const resetPayload = { ...newData };
    if (protocolFields.includes('client_id') && contato) {
      alterDefaultModalData({
        clientId: contato?.id,
        clientName: contato?.nome,
        clientPhone: contato?.telefone,
        clientEmail: contato?.email
      });
      resetPayload.client = { label: contato?.nome, value: contato?.id };
      resetPayload.telephone = contato?.telefone || '';
    }

    reset(resetPayload);

    if (protocolFields.includes('account_id') && conta) {
      const acc = {
        id: conta?.value,
        name: conta?.label,
        recordTypeId: conta?.record_type_id
      };
      selectedAccountRef.current = acc;
      const schedule = (fn) =>
        typeof queueMicrotask === 'function'
          ? queueMicrotask(fn)
          : Promise.resolve().then(fn);
      schedule(() => {
        setSelectedAccount(acc);
      });
    }
  };

  const renderServiceClassificationName = () => {
    if (isLoadingServiceClassificationName) {
      return <Loader type="ThreeDots" visible={true} height="30" width="30" />;
    }

    if (serviceClassificationName) {
      const { name, times } = serviceClassificationName;

      let formattedTimeSolution, formattedTimeService;
      if (times) {
        formattedTimeSolution = formatTimeToDHM(times.solution);
        formattedTimeService = formatTimeToDHM(times.service);
      }

      return (
        <>
          <span>{` ${name}`}</span>
          {formattedTimeService && (
            <>
              {` | Tempo de Atendimento: `}
              <span title={formattedTimeService}>{formattedTimeService}</span>
            </>
          )}
          {formattedTimeSolution && (
            <>
              {` | Tempo de Solução: `}
              <span title={formattedTimeSolution}>{formattedTimeSolution}</span>
            </>
          )}
        </>
      );
    }

    if (customerPortfolio && !customerPortfolio.sla_matrix_id) {
      const message =
        'A categoria da conta selecionada não possui matriz de SLA cadastrada, portanto o SLA não será aplicado a esse protocolo';
      return <span title={message}>{` ${message}`}</span>;
    }

    return (
      <span>
        {` Selecione uma conta, para visualizar a classificação de serviço`}
      </span>
    );
  };

  /**
   * Handles the contact change when a client is selected in the form.
   *
   * This function is typically used as an `onChange` callback for a controlled field (e.g., a Select).
   * When a client is selected, it updates the default modal state with:
   * - Client name
   * - Client ID
   * - Telephone number
   * - Email address
   *
   * After updating the modal state, it calls `reset` to update the form fields,
   * specifically setting the selected client and phone number. The `telephone` field
   * is updated explicitly because it might be decoupled from the client field
   *
   * @param {Object} data - Selected client data.
   * @param {string} data.label - Client name.
   * @param {string} data.value - Client ID.
   * @param {string} [data.telephone] - Client's phone number.
   * @param {string} [data.email] - Client's email address.
   */
  const handleContactChange = (data) => {
    if (!data)
      console.warn(
        'Attempted to update contact field with invalid data. Please check the "data" parameter.'
      );

    const { label, value, telephone, email } = data;
    setSelectedAccount(null);

    alterDefaultModalData({
      clientId: value,
      clientName: label,
      clientPhone: telephone,
      clientEmail: email
    });
    hydrateAccountFromContact(value);

    const hasEmailField = protocolDefaultFieldsDisplaySettings?.email?.isActive;
    const currentEmail = formValues.email;

    if (
      hasEmailField &&
      email &&
      (!currentEmail || currentEmail.trim() === '')
    ) {
      setValue('email', email);
    }
  };

  useEffect(() => {
    if (props?.conversation?.cliente) {
      reset({
        telephone: {
          ddi: props.conversation.cliente.ddi || '',
          number: props.conversation.cliente.telefone || ''
        }
      });
    }
  }, [props?.conversation?.cliente, reset]);

  useEffect(() => {
    getServiceChannels();
  }, [getServiceChannels]);

  // For subprotocol creation, specifying a responsible is not required.
  const hasRequiredCurrentResponsible =
    protocolDefaultFieldsDisplaySettings &&
    protocolDefaultFieldsDisplaySettings.current_responsible &&
    !props.fatherProtocol;
  const currentResponsibleDefaultValue =
    loggedInUser ||
    (protocolDefaultFieldsDisplaySettings?.current_responsible?.isActive &&
    !protocolDefaultFieldsDisplaySettings?.current_responsible
      ?.isOnlyToShowOnEdit &&
    protocolDefaultFieldsDisplaySettings?.current_responsible?.defaultValue !==
      ''
      ? protocolDefaultFieldsDisplaySettings?.current_responsible?.defaultValue
      : '');
  return (
    <>
      {loadingForm ? (
        <Row className="justify-content-md-center">
          <ReactLoader />
        </Row>
      ) : (
        <>
          {recordTypeData && recordTypeData.is_sla_active && (
            <ServiceClassificationNameWrapper>
              <p>
                Esse protocolo possui SLA ativo, com a classificação de serviço
                de:{' '}
              </p>
              <div
                style={{
                  width: '100%'
                }}
              >
                {renderServiceClassificationName()}
              </div>
            </ServiceClassificationNameWrapper>
          )}
          {config && !!config?.timeToFillProtocolForm?.enabled && (
            <Counter
              isPaused={pauseCounter}
              initialSeconds={config?.timeToFillProtocolForm?.value ?? 0}
            ></Counter>
          )}
          {props.fatherProtocol &&
            (localStorage.getItem('isFromUpdate') === true ||
              localStorage.getItem('isFromUpdate') === 'true') && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  paddingRight: '13px'
                }}
              >
                <Button
                  type="button"
                  style={{
                    alignSelf: 'flex-end',
                    marginLeft: 10,
                    backgroundColor: `#0000ff`,
                    color: 'white'
                  }}
                  onClick={() => {
                    cloneParentProtocol();
                  }}
                >
                  Clonar Campos Pai
                </Button>
              </div>
            )}

          {propsMemo && (
            <Form
              className="needs-validation"
              onSubmit={handleSubmit(onSubmit)}
            >
              {protocolDefaultFieldsDisplaySettings && recordType && (
                <StyledGridLayout
                  className="layout"
                  layout={layouts}
                  breakpoints={{
                    lg: 1200,
                    md: 996,
                    sm: 768,
                    xs: 480,
                    xxs: 0
                  }}
                  cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 4 }}
                  rowHeight={84}
                  isDraggable={false}
                  isResizable={false}
                >
                  <div
                    key={'protocolNumber'}
                    className="react-grid-layout-box"
                    data-grid={
                      (layouts &&
                        layouts.length > 0 &&
                        layouts.find(
                          (item) => item.i === 'protocolNumber'
                        )) || {
                        x: 2,
                        y: 0,
                        w: 2,
                        h: 1,
                        minW: 2,
                        maxW: 4,
                        minH: 1,
                        maxH: 1,
                        static: true
                      }
                    }
                  >
                    {protocolNumber && (
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                      >
                        <FaRegCalendarAlt
                          style={{
                            fontSize: '1.4rem',
                            display: 'inline',
                            color: 'rgb(0, 100, 140)',
                            cursor: 'pointer',
                            marginRight: '0.2rem',
                            marginTop: '2rem'
                          }}
                          id="tour4"
                          onClick={() => setIsSchedulingModalOpen(true)}
                        />
                        <Col id="tour1">
                          <label className="form-control-label">
                            Nº. do Protocolo
                          </label>
                          <Controller
                            as={Input}
                            control={control}
                            name="number"
                            disabled={true}
                            defaultValue={protocolNumber}
                          />
                        </Col>
                      </div>
                    )}
                  </div>
                  {protocolDefaultFieldsDisplaySettings?.title?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.title
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'title'}
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find((item) => item.i === 'title')) || {
                            x: 0,
                            y: 1,
                            w: 4,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                      >
                        <Row className="mb-3">
                          <Col className="tour2">
                            <label className="form-control-label">
                              {definedShowName(
                                'Título',
                                protocolDefaultFieldsDisplaySettings.title
                                  .isRequired
                              )}
                            </label>
                            <Controller
                              as={Input}
                              control={control}
                              tabIndex={
                                sortedLayouts.findIndex(
                                  (item) => item.i === 'title'
                                ) + 1
                              }
                              name="title"
                              rules={validateFields(
                                protocolDefaultFieldsDisplaySettings.title
                                  .isRequired
                              )}
                              defaultValue={
                                conversation
                                  ? `[Protocolo Automático]: Contato ${conversation.cliente.nome} via ${conversation.canal}`
                                  : ''
                              }
                            />
                            <ErrorMessage
                              errors={errors}
                              name="title"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.client_id?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.client_id
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'client_id'}
                        className="react-grid-layout-box"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find((item) => item.i === 'client_id')) || {
                            x: 0,
                            y: 2,
                            w: 2,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                        style={{
                          zIndex: '1'
                        }}
                      >
                        <div className="d-flex">
                          <div style={{ flexGrow: '10' }} className="tour3">
                            <label className="form-control-label">
                              {definedShowName(
                                'Contato',
                                protocolDefaultFieldsDisplaySettings.client_id
                                  .isRequired
                              )}
                            </label>

                            <Controller
                              name="client"
                              control={control}
                              valueController={setValue}
                              defaultValue={
                                clientDefaultData && clientDefaultData.client
                                  ? {
                                      label:
                                        clientDefaultData.client.nome || '',
                                      value: clientDefaultData.client.id
                                    }
                                  : '' || conversation
                                  ? {
                                      label: conversation.cliente.nome || '',
                                      value: getIdClientFromChat(conversation)
                                    }
                                  : ''
                              }
                              rules={{
                                validate: (value) => {
                                  const isRequired =
                                    protocolDefaultFieldsDisplaySettings
                                      ?.client_id?.isRequired;
                                  if (isRequired && !value)
                                    return 'Campo obrigatório';
                                  if (!isRequired && !value) return true;
                                }
                              }}
                              render={() => (
                                <Select
                                  styles={custom_select}
                                  placeholder="Busca rápida..."
                                  tabIndex={
                                    sortedLayouts.findIndex(
                                      (item) => item.i === 'client_id'
                                    ) + 1
                                  }
                                  isClearable={false}
                                  loadOptions={async (inputValue) => {
                                    const res = await filterClients(inputValue);
                                    return res;
                                  }}
                                  isLoading={isSearching}
                                  loadingMessage={() => 'Buscando...'}
                                  noOptionsMessage={({ inputValue }) =>
                                    !inputValue
                                      ? 'Digite para pesquisar'
                                      : 'Nenhum resultado encontrado'
                                  }
                                  onChange={handleContactChange}
                                  value={
                                    clientDefaultData &&
                                    clientDefaultData.client
                                      ? {
                                          label:
                                            clientDefaultData.client.nome || '',
                                          value: clientDefaultData.client.id
                                        }
                                      : ''
                                  }
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="client"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </div>

                          <div
                            style={{
                              alignSelf: 'flex-end',
                              justifyContent: 'space-between',
                              padding: '0.6rem 0.6rem'
                            }}
                          >
                            <SearchContactButton
                              onClick={() => setIsClientSearchModalOpen(true)}
                            />

                            <AddContactModal
                              setSelectedContact={alterDefaultModalData}
                              protocolTelephoneNumber={
                                protocolTelephoneNumber || ''
                              }
                              buttonOpenModal={({ onClick }) => (
                                <AddNewContactButton onClick={onClick} />
                              )}
                            />

                            {clientDefaultData.client?.nome && (
                              <FaHistory
                                style={{
                                  fontSize: '1.6rem',
                                  display: 'inline',
                                  color: 'rgb(0, 150, 0)',
                                  cursor: 'pointer',
                                  paddingLeft: '0.2rem'
                                }}
                                onClick={() => toggleHistoryModalProtocol()}
                                id="tour4"
                              />
                            )}
                          </div>
                        </div>

                        {controlValidSelectClient &&
                          errorFormMessage('Campo obrigatório')}
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.telephone?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.telephone
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'telephone'}
                        className="react-grid-layout-box"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find((item) => item.i === 'telephone')) || {
                            x: 2,
                            y: 2,
                            w: 2,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                      >
                        <FlexController
                          type="phone"
                          label={definedShowName(
                            'Telefone',
                            protocolDefaultFieldsDisplaySettings.telephone
                              .isRequired
                          )}
                          name="telephone"
                          disabled={false}
                          showMessageButton={false}
                          showCallButton={false}
                          watch={watch}
                          value={
                            watch('telephone') ??
                            (protocolTelephoneNumber
                              ? convertPhoneToFlexControllerFormat(
                                  protocolTelephoneNumber
                                )
                              : clientDefaultData?.telephoneNumber
                              ? convertPhoneToFlexControllerFormat(
                                  clientDefaultData.telephoneNumber
                                )
                              : {
                                  ddi: getDefaultCountry()?.dialCode || '',
                                  number: ''
                                })
                          }
                          control={control}
                          errors={errors}
                          rules={{
                            validate: (value) => {
                              const isRequired =
                                protocolDefaultFieldsDisplaySettings?.telephone
                                  ?.isRequired;

                              if (!isRequired) {
                                return true;
                              }

                              if (
                                value &&
                                typeof value === 'object' &&
                                value.number
                              ) {
                                const phoneFormated = value.number
                                  .replace(/\D/g, '')
                                  .replace(/^0/, '');

                                const isBrazilDDI =
                                  value.ddi === '55' || value.ddi === '+55';

                                if (isBrazilDDI && phoneFormated.length < 10) {
                                  return 'Telefone brasileiro deve ter pelo menos 10 dígitos';
                                }

                                if (
                                  !isBrazilDDI &&
                                  phoneFormated.length === 0
                                ) {
                                  return 'Campo obrigatório';
                                }

                                return true;
                              }

                              if (value && typeof value === 'string') {
                                const phoneFormated = value
                                  .replace(/\D/g, '')
                                  .replace(/^0/, '');

                                if (phoneFormated.length < 10) {
                                  return 'Telefone deve ter pelo menos 10 dígitos';
                                }
                                return true;
                              }

                              return 'Campo obrigatório';
                            }
                          }}
                          valueController={(fieldName, value) => {
                            setValue(fieldName, value);
                          }}
                        />
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.description
                    ?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.description
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'description'}
                        className="react-grid-layout-box tour5"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find(
                              (item) => item.i === 'description'
                            )) || {
                            x: 0,
                            y: 3,
                            w: 12,
                            h: 8,
                            minW: 6,
                            maxW: 12,
                            minH: 4,
                            maxH: 12
                          }
                        }
                        style={{
                          overflow: 'visible',
                          borderBottom: '1px solid #ced4da',
                          position: '0 1px 3px rgba(0,0,0,0.1)',
                          display: 'flex',
                          flexDirection: 'column'
                        }}
                        ref={descriptionRef}
                        onPaste={(e) => e.stopPropagation()}
                      >
                        <label
                          className="form-control-label mb-2"
                          style={{ fontWeight: 600, cursor: 'default' }}
                        >
                          {definedShowName(
                            'Descrição',
                            protocolDefaultFieldsDisplaySettings.description
                              .isRequired
                          )}
                        </label>
                        <div
                          style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: 0
                          }}
                        >
                          <Controller
                            render={({ onChange, value }) => (
                              <DescriptionQuillContainer
                                theme="snow"
                                placeholder="Escreva um comentário"
                                modules={modules}
                                value={value || ''}
                                onChange={onChange}
                                bounds={
                                  descriptionRef.current?.parentElement ||
                                  document.body
                                }
                              />
                            )}
                            control={control}
                            rules={validateFields(
                              protocolDefaultFieldsDisplaySettings.description
                                .isRequired
                            )}
                            name="description"
                            defaultValue=""
                          />
                        </div>
                        <ErrorMessage
                          errors={errors}
                          name="description"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.reason_id?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.reason_id
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'reason_id'}
                        className="react-grid-layout-box"
                        id="tour6"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find((item) => item.i === 'reason_id')) || {
                            x: 2,
                            y: 3,
                            w: 2,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                      >
                        <label className="form-control-label">
                          {definedShowName(
                            'Motivo',
                            protocolDefaultFieldsDisplaySettings.reason_id
                              .isRequired
                          )}
                        </label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={
                                reasons
                                  ? reasons.map(({ id, name }) => ({
                                      label: name,
                                      value: id
                                    }))
                                  : []
                              }
                              value={props.value}
                              valueController={setValue}
                              fieldName="reason_id"
                              labelName="label"
                              tabIndex={
                                sortedLayouts.findIndex(
                                  (item) => item.i === 'reason_id'
                                ) + 1
                              }
                              valueName="value"
                              isClearable={true}
                              closeMenuOnSelect={true}
                              portalTarget={true}
                              onChange={handleGetSubReasons}
                            />
                          )}
                          control={control}
                          name="reason_id"
                          rules={validateFields(
                            protocolDefaultFieldsDisplaySettings.reason_id
                              .isRequired
                          )}
                          defaultValue={''}
                        />

                        <ErrorMessage
                          errors={errors}
                          name="reason_id"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.subreason_id
                    ?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.subreason_id
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'subreason_id'}
                        className="react-grid-layout-box"
                        id="tour7"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find(
                              (item) => item.i === 'subreason_id'
                            )) || {
                            x: 2,
                            y: 4,
                            w: 2,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                      >
                        <label className="form-control-label">
                          {definedShowName(
                            'Submotivo',
                            protocolDefaultFieldsDisplaySettings.subreason_id
                              .isRequired
                          )}
                        </label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={
                                subReasons
                                  ? subReasons.map(({ id, name }) => ({
                                      label: name,
                                      value: id
                                    }))
                                  : []
                              }
                              tabIndex={
                                sortedLayouts.findIndex(
                                  (item) => item.i === 'subreason_id'
                                ) + 1
                              }
                              value={props.value}
                              valueController={setValue}
                              fieldName="subreason_id"
                              labelName="label"
                              valueName="value"
                              isClearable={true}
                              closeMenuOnSelect={true}
                              portalTarget={true}
                            />
                          )}
                          disabled={loadingSubreasons}
                          control={control}
                          name="subreason_id"
                          defaultValue=""
                          rules={validateFields(
                            protocolDefaultFieldsDisplaySettings.subreason_id
                              .isRequired
                          )}
                        />

                        <ErrorMessage
                          errors={errors}
                          name="subreason_id"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.account_id?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.account_id
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'account_id'}
                        className="react-grid-layout-box"
                        style={{ zIndex: '1' }}
                        id="tour7"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find(
                              (item) => item.i === 'account_id'
                            )) || {
                            x: 2,
                            y: 5,
                            w: 2,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                      >
                        <label className="form-control-label">
                          {definedShowName(
                            'Conta',
                            protocolDefaultFieldsDisplaySettings.account_id
                              .isRequired
                          )}
                        </label>

                        <div className="d-flex">
                          <div style={{ flexGrow: '10' }} className="tour3">
                            <Select
                              styles={custom_select}
                              placeholder="Busca rápida"
                              isClearable={true}
                              name="accountId"
                              isLoading={isSearchingAccounts}
                              loadingMessage={() => 'Buscando...'}
                              noOptionsMessage={({ inputValue }) =>
                                !inputValue
                                  ? 'Digite para pesquisar'
                                  : 'Nenhum resultado encontrado'
                              }
                              loadOptions={async (inputValue) => {
                                const res = await filterAccounts(inputValue);
                                return (
                                  res?.map((acc) => ({
                                    label: acc.name,
                                    value: acc.id,
                                    recordTypeId: acc?.record_type_id
                                  })) ?? []
                                );
                              }}
                              onChange={(data) => {
                                if (data) {
                                  setSelectedAccount({
                                    id: data.value,
                                    name: data.label,
                                    recordTypeId: data.recordTypeId
                                  });
                                } else {
                                  setSelectedAccount(null);
                                }
                              }}
                              value={
                                selectedAccount
                                  ? {
                                      label: selectedAccount.name,
                                      value: selectedAccount.id
                                    }
                                  : null
                              }
                              components={{
                                DropdownIndicator: () => (
                                  <div
                                    onMouseDown={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setIsAccountSearchModalOpen(true);
                                    }}
                                    style={{
                                      padding: '0.6rem',
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center'
                                    }}
                                  >
                                    <SearchContactButton
                                      onClick={() =>
                                        setIsAccountSearchModalOpen(true)
                                      }
                                      style={{ margin: 0, padding: 0 }}
                                    />
                                  </div>
                                )
                              }}
                            />

                            {controlValidSelectAccount && (
                              <p style={{ color: 'red' }}>Campo obrigatório</p>
                            )}
                          </div>

                          <div
                            style={{
                              alignSelf: 'flex-end',
                              justifyContent: 'space-between',
                              padding: '0.6rem 0.6rem',
                              marginLeft: '0.2rem'
                            }}
                          >
                            <Button
                              size="sm"
                              color="info"
                              type="button"
                              title="Editar conta"
                              onClick={handleEditAccount}
                              disabled={!selectedAccount}
                            >
                              <li className="fas fa-user-edit"></li>
                            </Button>
                          </div>

                          <div
                            style={{
                              alignSelf: 'flex-end',
                              justifyContent: 'space-between',
                              padding: '0.6rem 0.6rem',
                              marginLeft: '-0.5rem'
                            }}
                          >
                            <AddAccountModal
                              onAddedAccount={onAddedAccount}
                              buttonOpenModal={({ onClick }) => (
                                <AddNewContactButton onClick={onClick} />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.service_channel
                    ?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.service_channel
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'service_channel'}
                        className="react-grid-layout-box tour8"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find(
                              (item) => item.i === 'service_channel'
                            )) || {
                            x: 0,
                            y: 6,
                            w: 2,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                      >
                        <label className="form-control-label">
                          {definedShowName(
                            'Canal de atendimento',
                            protocolDefaultFieldsDisplaySettings.service_channel
                              .isRequired
                          )}
                        </label>

                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={serviceChannelOptions}
                              value={props.value}
                              valueController={setValue}
                              tabIndex={
                                sortedLayouts.findIndex(
                                  (item) => item.i === 'service_channel'
                                ) + 1
                              }
                              fieldName="service_channel"
                              labelName="label"
                              valueName="value"
                              isClearable={true}
                              closeMenuOnSelect={true}
                              portalTarget={true}
                            />
                          )}
                          control={control}
                          name="service_channel"
                          rules={validateFields(
                            protocolDefaultFieldsDisplaySettings
                              ?.service_channel.isRequired
                          )}
                          defaultValue={
                            clientDefaultData?.serviceChannel ||
                            (conversation &&
                              conversation?.canal?.toUpperCase()) ||
                            ''
                          }
                        />

                        <ErrorMessage
                          errors={errors}
                          name="service_channel"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.current_status
                    ?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.current_status
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'current_status'}
                        className="react-grid-layout-box tour8"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find(
                              (item) => item.i === 'current_status'
                            )) || {
                            x: 2,
                            y: 6,
                            w: 2,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                      >
                        <label className="form-control-label">
                          {definedShowName(
                            'Status/Fase',
                            protocolDefaultFieldsDisplaySettings.current_status
                              .isRequired
                          )}
                        </label>

                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={
                                status
                                  ? status.map(({ id, name }) => ({
                                      label: name,
                                      value: id
                                    }))
                                  : []
                              }
                              value={props.value}
                              valueController={setValue}
                              tabIndex={
                                sortedLayouts.findIndex(
                                  (item) => item.i === 'current_status'
                                ) + 1
                              }
                              fieldName="current_status"
                              labelName="label"
                              valueName="value"
                              isClearable={true}
                              closeMenuOnSelect={true}
                              portalTarget={true}
                            />
                          )}
                          control={control}
                          name="current_status"
                          rules={validateFields(
                            protocolDefaultFieldsDisplaySettings?.current_status
                              .isRequired
                          )}
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="current_status"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.current_responsible
                    ?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.current_responsible
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'current_responsible'}
                        className="react-grid-layout-box"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find(
                              (item) => item.i === 'current_responsible'
                            )) || {
                            x: 0,
                            y: 6,
                            w: 2,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                      >
                        <label className="form-control-label">
                          {definedShowName(
                            'Responsável Atual',
                            hasRequiredCurrentResponsible
                          )}
                        </label>

                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={usersOptions}
                              value={props.value}
                              valueController={setValue}
                              tabIndex={
                                sortedLayouts.findIndex(
                                  (item) => item.i === 'current_responsible'
                                ) + 1
                              }
                              fieldName="current_responsible"
                              labelName="label"
                              valueName="value"
                              isClearable={true}
                              closeMenuOnSelect={true}
                              portalTarget={true}
                            />
                          )}
                          control={control}
                          name="current_responsible"
                          rules={validateFields(hasRequiredCurrentResponsible)}
                          defaultValue={currentResponsibleDefaultValue}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="current_responsible"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.notification_agent
                    ?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.notification_agent
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'notification_agent'}
                        className="react-grid-layout-box"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find(
                              (item) => item.i === 'notification_agent'
                            )) || {
                            x: 0,
                            y: 6,
                            w: 2,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                      >
                        <label>
                          {definedShowName(
                            'Agente de Notificação',
                            protocolDefaultFieldsDisplaySettings
                              .notification_agent.isRequired
                          )}
                        </label>

                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={usersOptions}
                              value={props.value}
                              valueController={setValue}
                              tabIndex={
                                sortedLayouts.findIndex(
                                  (item) => item.i === 'notification_agent'
                                ) + 1
                              }
                              fieldName="agentId"
                              labelName="label"
                              valueName="value"
                              isClearable={true}
                              closeMenuOnSelect={true}
                              portalTarget={true}
                            />
                          )}
                          control={control}
                          name="agentId"
                          rules={validateFields(
                            protocolDefaultFieldsDisplaySettings
                              ?.notification_agent.isRequired
                          )}
                        />
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.email?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.email
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'email'}
                        className="react-grid-layout-box"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find((item) => item.i === 'email')) || {
                            x: 2,
                            y: 7,
                            w: 2,
                            h: 1,
                            minW: 2,
                            maxW: 4,
                            minH: 1,
                            maxH: 1,
                            static: true
                          }
                        }
                      >
                        <label className="form-control-label">
                          {definedShowName(
                            'Email',
                            protocolDefaultFieldsDisplaySettings.email
                              .isRequired
                          )}
                        </label>
                        <Controller
                          as={Input}
                          type="email"
                          tabIndex={
                            sortedLayouts.findIndex(
                              (item) => item.i === 'email'
                            ) + 1
                          }
                          control={control}
                          name="email"
                          rules={{
                            validate: (value) => {
                              const isRequired =
                                protocolDefaultFieldsDisplaySettings.email
                                  .isRequired;
                              if (isRequired && !value)
                                return 'Campo obrigatório';
                              if (!isRequired && !value) return true;

                              const emailRegex =
                                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

                              return (
                                emailRegex.test(value) ||
                                'Email com formato incorreto'
                              );
                            }
                          }}
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="email"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </div>
                    )}

                  {protocolDefaultFieldsDisplaySettings?.files?.isActive &&
                    !protocolDefaultFieldsDisplaySettings?.files
                      ?.isOnlyToShowOnEdit && (
                      <div
                        key={'files'}
                        className="react-grid-layout-box"
                        data-grid={
                          (layouts &&
                            layouts.length > 0 &&
                            layouts.find((item) => item.i === 'files')) || {
                            x: 2,
                            y: 7,
                            w: 4,
                            h: 2,
                            minW: 4,
                            maxW: 4,
                            minH: 4,
                            maxH: 4,
                            static: false
                          }
                        }
                      >
                        <label className="form-control-label">
                          {definedShowName(
                            'Arquivos',
                            protocolDefaultFieldsDisplaySettings?.files
                              ?.isRequired || false
                          )}
                        </label>
                        <Controller
                          name="files"
                          as={
                            <>
                              <FileProtocolArea htmlFor="files">
                                <label
                                  style={{
                                    margin: '0',
                                    padding: '0'
                                  }}
                                >
                                  <UploadButtonProtocol>
                                    {loadingFile ? (
                                      <>Carregando...</>
                                    ) : (
                                      <>
                                        <span>Enviar arquivo</span>
                                        <FiUpload />
                                      </>
                                    )}
                                  </UploadButtonProtocol>

                                  <Input
                                    id="files"
                                    style={{ display: 'none' }}
                                    type="file"
                                    disabled={loadingFile}
                                    onChange={handlerSelectFiles}
                                    multiple={true}
                                    accept="application/pdf, image/*,.txt"
                                  />
                                </label>
                              </FileProtocolArea>
                            </>
                          }
                          control={control}
                          rules={{
                            validate: (value) => {
                              const isRequired =
                                protocolDefaultFieldsDisplaySettings?.files
                                  ?.isRequired;
                              if (isRequired && !value)
                                return 'Campo obrigatório';
                              if (!isRequired && !value) return true;
                            }
                          }}
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="files"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </div>
                    )}

                  {customFields && renderCustomFields()}
                </StyledGridLayout>
              )}
              {!inAttendanceScreen && <hr />}
              {protocolDefaultFieldsDisplaySettings?.files?.isActive &&
                !loadingFile &&
                attachments && (
                  <>
                    <label className="form-control-label">
                      Arquivos anexados
                    </label>
                    {errorInUpload && successCreateProtocolo.success && (
                      <Alert color="secondary">
                        Protocolo criado com sucesso, mas houve erro no envio
                        dos anexos. Por favor, tente novamente.
                      </Alert>
                    )}
                    {messageError && (
                      <Alert color="secondary">
                        {errorFormMessage(messageError)}
                      </Alert>
                    )}

                    <AreaPreviewProtocol>
                      <ListFileAttachments
                        files={fileAttachmentsPreview}
                        setLoadingFile={setLoadingFile}
                        loadingFiles={loadingFile}
                        setValue={setValue}
                        setMessageError={setMessageError}
                      />
                    </AreaPreviewProtocol>
                  </>
                )}
              {propsMemo && (
                <Row>
                  <Col md="6">
                    {!inAttendanceScreen && (
                      <>
                        <Button
                          key={'save'}
                          color="primary"
                          type="submit"
                          disabled={loading}
                          tabIndex={
                            sortedLayouts.findIndex(
                              (item) => item.i === 'save'
                            ) + 1
                          }
                        >
                          {loading ? (
                            <Loader
                              type="TailSpin"
                              color="#fff"
                              height={20}
                              width={20}
                            />
                          ) : errorInUpload &&
                            successCreateProtocolo.success &&
                            fileAttachmentsPreview?.attachmentsName.length ? (
                            'Reenviar Anexos'
                          ) : successCreateProtocolo.success &&
                            fileAttachmentsPreview?.attachmentsName.length ==
                              0 ? (
                            'Atualizar Protocolo'
                          ) : (
                            'Salvar'
                          )}
                        </Button>
                        <Button
                          key={'cancel'}
                          color="danger"
                          tabIndex={
                            sortedLayouts.findIndex(
                              (item) => item.i === 'cancel'
                            ) + 1
                          }
                          onClick={() => {
                            if (
                              fileAttachmentsPreview.attachments.length > 0 &&
                              successCreateProtocolo.success &&
                              errorInUpload
                            ) {
                              const result = window.confirm(
                                'Se você cancelar, os arquivos anexados serão perdidos. Deseja continuar?'
                              );

                              if (!result) return;
                            }

                            closeModal();
                            changeFieldsReference({});
                            fileAttachmentsPreview.reset();
                          }}
                        >
                          Cancelar
                        </Button>
                      </>
                    )}
                  </Col>
                  <Col md="6">
                    <Button
                      className="float-right "
                      type="button"
                      outline
                      color="info"
                      onClick={openTour}
                      title="Saiba mais sobre o protocolo"
                    >
                      Saiba Mais
                    </Button>
                  </Col>
                </Row>
              )}
            </Form>
          )}
        </>
      )}

      <ModalFilterClients
        className="modal-lg"
        show={isAccountSearchModalOpen}
        onModalToggle={setIsAccountSearchModalOpen}
        setSelectedClient={(account) => {
          setSelectedAccount({
            id: account?.clientId,
            name: account?.clientName,
            recordTypeId: account?.accountRecordTypeId
          });
          setIsAccountSearchModalOpen(false);
        }}
        account={true}
      />

      <ModalFilterClients
        className="modal-lg"
        show={isClientSearchModalOpen}
        onModalToggle={setIsClientSearchModalOpen}
        setSelectedClient={alterDefaultModalData}
      />

      <EditAccountModal
        isModalOpen={isEditAccountModalOpen}
        onModalToggle={setIsEditAccountModalOpen}
        account={accountResponse}
        recordTypeId={selectedAccount?.recordTypeId}
        setSelectedClient={(account) => {
          setSelectedAccount({
            id: account?.clientId,
            name: account?.clientName,
            recordTypeId: account?.accountRecordTypeId
          });
        }}
      />

      <ModalConfirmAssociateContact
        show={showAssociateModal}
        onModalToggle={setShowAssociateModal}
        onConfirm={handleConfirmAssociate}
        onCancel={handleContinueWithoutAssociate}
        contactName={nameClient || clientDefaultData?.client?.nome || ''}
        accountName={selectedAccount?.name || ''}
      />

      <ModalSchedulingProtocol
        className="modal-lg"
        show={isSchedulingModalOpen}
        onModalToggle={setIsSchedulingModalOpen}
        setSelectedSchedule={setSelectedSchedule}
        isToCreate={false}
      />

      {clientDefaultData.client?.nome && (
        <ClientProtocolModal
          isModalOpen={isHistoryModalProtocolOpen}
          toggleModal={toggleHistoryModalProtocol}
          clientInfo={nameClient}
          clientId={clientDefaultData?.client?.id}
          recordTypes={1}
          isProtocolScreen={true}
        />
      )}

      <Tour steps={steps} isOpen={tourOpen} onRequestClose={closeTour} />
    </>
  );
};

export default ProtocolForm;
